import { Link } from "react-router-dom";

function Footer() {
    return (<>
     {/* Start Footer Area */}
     <div className="footer-area pt-100">
      <div className="container">
        <div className="row pb-100">
          <div className="col-lg-3 col-sm-6 col-md-6" >
            <div className="footer-widget">
             
              <img
                    src="assets/images/SSC.svg"
                  className="black-logo"
                  alt="image"
                />
          
              <p>
              Using data and technology innovations, we help you choose the most suited offers across loans and cards. 
              </p>
              {/* <ul className="follow-list">
                <li>
                  <Link to="https://www.facebook.com/" target="_blank">
                    <i className="bx bxl-facebook" />
                  </Link>
                </li>
                <li>
                  <a href="https://twitter.com/" target="_blank">
                    <i className="bx bxl-twitter" />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/" target="_blank">
                    <i className="bx bxl-linkedin" />
                  </a>
                </li>
                <li>
                  <a href="https://www.google.com/" target="_blank">
                    <i className="bx bxl-google" />
                  </a>
                </li>
              </ul> */}
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6" >
            <div className="footer-widget footer-widget-link2">
              <h2>About Us</h2>
              <ul className="footer-widget-list">
                <li>
                <Link to="/" className="nav-link active">
                    Home
                 
                  </Link>
          
                </li>
                <li>
                <Link to="/about" className="nav-link active">
                    About Us
                 
                  </Link>
          
                </li>
             
                 {/*<li>
                <Link to="/news-blogs" className="nav-link">
                    News & Blog
                  </Link>
                 
                </li> */}
                <li>
                <Link to="/contact" className="nav-link">
                    Contact Us
                  </Link>
                </li>
                <li>
                <Link to="/terms" className="nav-link active">
                    Terms & Conditions
                 
                  </Link>
          
                </li>
                <li>
                <Link to="/privacy" className="nav-link active">
                    Privacy Policy
                 
                  </Link>
          
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6" >
            <div className="footer-widget footer-widget-link">
              <h2>Our Services</h2>
              <ul className="footer-widget-list">
                <li>
                <Link to="/banking-services" className="nav-link">
                        Banking Services
                      </Link>
                </li>
                <li>
                <Link to="/insurance-services" className="nav-link">
                       Insurance Services
                      </Link>
                </li>
                <li>
                <Link to="/wallet-services" className="nav-link">
                       Wallet Services
                      </Link>
                </li>
                <li>
                <Link to="/g2c-services" className="nav-link">
                       G2C Services
                      </Link>
                </li>
           
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6" >
            <div className="footer-widget">
              <h2>Get In Touch</h2>
              <div className="touch-content">
                <div className="contact-icon">
                  <img src="assets/images/contact-phone.svg" alt="svg" />
                </div>
                <a href="tel:+91-9717111000">+91 - 9355200600</a>
              </div>
              <div className="touch-content">
                <div className="contact-icon">
                  <img src="assets/images/contact-mail.svg" alt="svg" />
                </div>
                <a href="#">
                  <span
                    className="__cf_email__"
                  >
                    info@smartuworld.com
                  </span>
                </a>
              </div>
              <div class="touch-content">
                                <div class="contact-icon">
                                    <img src="assets/images/contact-map.svg" alt="svg" />
                                </div>
                                <p>6146/7, D-6 , Vasant Kunj, Delhi - 110070
                                India</p>
                            </div>
             
            </div>
          </div>
        </div>
      </div>
      <div className="footer-shape-1">
        <img src="assets/images/footer-shape-1.webp" alt="footer" />
      </div>
      <div className="footer-shape-2">
        <img src="assets/images/footer-shape-2.webp" alt="footer" />
      </div>
      <div className="copyright-content">
        <div className="d-flex align-items-center justify-content-center">
          <p>
          Copyright @ 2024 SmartUWorld All Rights Reserved 
          </p>
        </div>
      </div>
    </div>
    {/* End Footer Area */}
 
      </>
    );
  }
  
  export default Footer;
  
